import { Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import DrawerButton from 'components/Views/Creative/Drawers/DrawerButton';
import type Template from 'stores/Template';
import { ProcessingStatus } from 'types/ProcessingStatus';

export interface RemoveTemplateButtonProps {
  template: Template;
}

function RemoveTemplateButton({ template }: RemoveTemplateButtonProps) {
  const confirmRemove = () => {
    template.data.status = ProcessingStatus.PENDING;
    void template.parent?.remove(template.id);
  };

  return (
    <Popconfirm
      cancelText="No"
      okText="Yes"
      onConfirm={confirmRemove}
      placement="bottomRight"
      title="Are you sure you want to remove this template?"
    >
      <DrawerButton disabled={template.loading}>Remove</DrawerButton>
    </Popconfirm>
  );
}

export default observer(RemoveTemplateButton);
